import React from 'react';
// import Lottie from 'lottie-react';
// import loadingSpinner from '/src/assets/loading_spinner.json'; 
import RiskOverviewStandardSectionHeader from '../RiskOverviewStandardSectionHeader/RiskOverviewStandardSectionHeader';
import './style.css';

const RiskOverviewSectionLoadingState = ({ title, intro_sentence }) => {
    
    const loading_spinner_url = 'https://d2dhzsfgxco53w.cloudfront.net/loading_spinner.json'
    
    return (
        <div className="risk-overview-section-loading-state">
            <RiskOverviewStandardSectionHeader title={title} />
            <p className="risk-overview-section-loading-state-intro-sentence text-align-center" dangerouslySetInnerHTML={{ __html: intro_sentence }} />
            <div className="loading-animation-dots-bars" />
            
            {/* <Lottie 
              animationData={loadingSpinner}
              loop={true} 
              style={{ width: 100, height: 100 }} 
            /> */}
        </div>
    );
};

export default RiskOverviewSectionLoadingState;
